import { render, staticRenderFns } from "./ProductPrint.vue?vue&type=template&id=960768d0&"
import script from "./ProductPrint.vue?vue&type=script&lang=js&"
export * from "./ProductPrint.vue?vue&type=script&lang=js&"
import style0 from "./ProductPrint.vue?vue&type=style&index=0&id=960768d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports